namespace RedBullMOBILE360.Utilities {

    @Serenity.Decorators.registerClass('RedBullMOBILE360.Utilities.ReAuthenticateNumbersDialog')
    export class ReAuthenticateNumbersDialog extends Serenity.EntityDialog<ReAuthenticateNumbersRow, any> {
        protected getFormKey() { return ReAuthenticateNumbersForm.formKey; }
        protected getIdProperty() { return ReAuthenticateNumbersRow.idProperty; }
        protected getLocalTextPrefix() { return ReAuthenticateNumbersRow.localTextPrefix; }
        protected getNameProperty() { return ReAuthenticateNumbersRow.nameProperty; }
        protected getService() { return ReAuthenticateNumbersService.baseUrl; }
        protected getDeletePermission() { return ReAuthenticateNumbersRow.deletePermission; }
        protected getInsertPermission() { return ReAuthenticateNumbersRow.insertPermission; }
        protected getUpdatePermission() { return ReAuthenticateNumbersRow.updatePermission; }

        protected form = new ReAuthenticateNumbersForm(this.idPrefix);
    }
}